"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPopper = require("react-popper");
var _Context = require("../../Context");
var _NavIcon = _interopRequireDefault(require("../Nav/NavIcon"));
var _Portal = _interopRequireDefault(require("../../../../components/Portal"));
var _Search = _interopRequireDefault(require("./icons/Search"));
var _Results = _interopRequireDefault(require("./Results"));
var _modifiers = require("./modifiers");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const reducer = (state, newState) => ({
  ...state,
  ...newState
});
const Search = ({
  solutions,
  disabled,
  searchValueHandler
}) => {
  const inputRef = (0, _react.useRef)(null);
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  const [state, setState] = (0, _react.useReducer)(reducer, {
    expanded: false,
    query: ''
  });
  const collapseEmptyInput = () => {
    if (!state.query) {
      setState({
        expanded: false,
        query: ''
      });
    }
  };
  const collapseOuterAction = () => {
    setState({
      expanded: false,
      query: ''
    });
  };
  const toggleState = () => {
    if (!state.expanded) {
      setState({
        expanded: true
      });
      if (inputRef) {
        inputRef.current.focus();
      }
    }
  };
  const queryChange = event => {
    setState({
      query: event.target.value
    });
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter' && searchValueHandler) {
      searchValueHandler(state.query);
    }
  };
  return _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(_reactPopper.Reference, null, ({
    ref
  }) => _react.default.createElement(_NavIcon.default, {
    action: toggleState,
    disabled: disabled
  }, _react.default.createElement(_styles.SearchWrapper, {
    ref: ref
  }, _react.default.createElement(_Search.default, null), _react.default.createElement(_styles.SearchInput, {
    ref: inputRef,
    placeholder: "Search",
    onBlur: collapseEmptyInput,
    onChange: queryChange,
    onKeyDown: handleKeyDown,
    value: state.query,
    expanded: state.expanded
  })))), !searchValueHandler && !!state.query.length && _react.default.createElement(_Portal.default, null, _react.default.createElement(_reactPopper.Popper, {
    strategy: "absolute",
    placement: "bottom",
    modifiers: (0, _modifiers.getModifiers)({
      closePopover: collapseOuterAction
    })
  }, ({
    ref,
    style,
    placement
  }) => _react.default.createElement(_styles.SearchPopover, {
    ref: ref,
    style: style,
    "data-placement": placement
  }, _react.default.createElement(_styles.Panel, {
    isPopup: true
  }, _react.default.createElement(_Results.default, {
    noSearchResult: locale.noSearchResult,
    solutions: solutions,
    query: state.query
  }))))));
};
var _default = exports.default = Search;